import { useEffect, useState } from 'react';
import { useApi, identityApiRef } from '@backstage/core-plugin-api';

const DEVOPS_GROUPS = ['group:default/devops', 'group:default/tribo-devops'];

/**
 * Returns true when the signed-in user belongs to any devops group
 * or is the local guest user (development mode).
 * While the identity is being resolved the hook returns `loading: true`.
 */
export function useDevopsAccess(): { allowed: boolean; loading: boolean } {
  const identityApi = useApi(identityApiRef);
  const [allowed, setAllowed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    identityApi
      .getBackstageIdentity()
      .then(identity => {
        if (!cancelled) {
          // Guest user (local dev) gets full access — matches any namespace
          if (identity.userEntityRef.startsWith('user:') && identity.userEntityRef.endsWith('/guest')) {
            setAllowed(true);
            return;
          }
          const refs = identity.ownershipEntityRefs ?? [];
          setAllowed(DEVOPS_GROUPS.some(g => refs.includes(g)));
        }
      })
      .catch(() => {
        if (!cancelled) setAllowed(false);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [identityApi]);

  return { allowed, loading };
}
